var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00138 12.75C11.7479 12.75 14.1501 13.9312 15.4566 15.6937L14.0751 16.347C13.0116 15.087 11.1366 14.25 9.00138 14.25C6.86613 14.25 4.99113 15.087 3.92763 16.347L2.54688 15.693C3.85337 13.9305 6.25487 12.75 9.00138 12.75ZM9.00138 1.5C9.99594 1.5 10.9498 1.89509 11.653 2.59835C12.3563 3.30161 12.7514 4.25544 12.7514 5.25V7.5C12.7513 8.46635 12.3782 9.39537 11.7099 10.0933C11.0415 10.7913 10.1296 11.2043 9.16412 11.2463L9.00138 11.25C8.00681 11.25 7.05299 10.8549 6.34972 10.1517C5.64646 9.44839 5.25137 8.49456 5.25137 7.5V5.25C5.25143 4.28365 5.62453 3.35463 6.29287 2.65667C6.96121 1.95871 7.87319 1.54569 8.83862 1.50375L9.00138 1.5ZM9.00138 3C8.42747 2.99997 7.87524 3.21924 7.45768 3.61296C7.04012 4.00668 6.78879 4.54508 6.75513 5.118L6.75138 5.25V7.5C6.75081 8.08568 6.97864 8.6485 7.38645 9.06886C7.79427 9.48923 8.34992 9.73401 8.93535 9.7512C9.52077 9.76839 10.0898 9.55662 10.5216 9.1609C10.9534 8.76519 11.2138 8.2167 11.2476 7.632L11.2514 7.5V5.25C11.2514 4.65326 11.0143 4.08097 10.5924 3.65901C10.1704 3.23705 9.59811 3 9.00138 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNav);
export default __webpack_public_path__ + "static/media/profile-nav.0b95fb45f1593da79d750421817a1a44.svg";
export { ForwardRef as ReactComponent };